import { AsyncActionStatus } from '../enums';

export const createActionType = (domain, eventName) => `${domain}/${eventName}`;

export const createAsyncActionTypes = (domain, eventName) => ({
  [AsyncActionStatus.PENDING]: `${domain}/${eventName}/${AsyncActionStatus.PENDING.description}`,
  [AsyncActionStatus.FULFILLED]: `${domain}/${eventName}/${AsyncActionStatus.FULFILLED.description}`,
  [AsyncActionStatus.REJECTED]: `${domain}/${eventName}/${AsyncActionStatus.REJECTED.description}`,
});
